/* 완제품 관리 */
import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useProductStockManageMent } from '../../stores/product/productStockManagement/ProductStockManagementAction';
import { useProductIn } from '../../stores/product/productIn/ProductInAction';
import { useProductOut } from '../../stores/product/productout/ProductOutAction';

import Search from '../../components/Search/Search'
import Table from '../../components/Table/Table/Table';
import BaseModal from '../../components/Modal/Base/BaseModal';
import CrudModal from '../../components/Modal/Crud/CrudModal';
import ConfirmModal from '../../components/Modal/Confirm/ConfirmModal';

import { productStockManageManagementColumns, productInColumns, productOutColumns,
  productInFormFields, productOutFormFields, productStockSearchFormFields
} from './context';

import { FaInfo, FaWarehouse } from 'react-icons/fa';
import './ProductStockManagement.css';

const FinalProductManagement = () => {

  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const ProductStockManagement = useSelector((state) => state.productStockManageManagement);
  const ProductStockManagementApi = useProductStockManageMent();
  const ProductIn = useSelector((state) => state.productIn);
  const ProductInApi = useProductIn();
  const productOut = useSelector((state) => state.productOut);
  const productOutApi = useProductOut();

  const [selectedRows, setSelectedRows] = useState([]);
  const [clickedRow, setClickedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  const closeModal = () => {
    setIsOpen(false);
  };

  const searchProductStockManagement = (params = {}) => {
    params.companySeq = session.companySeq
    dispatch(ProductStockManagementApi.request.get(params));
  }

  const searchProductIn = (params) => {
    dispatch(ProductInApi.request.get(params));
  }
  const addProductIn = async (data) => {
    data.companySeq = session.companySeq
    data.productSeq = clickedRow.productSeq
    await ProductInApi.request.post(data);
    searchProductStockManagement({ page: currentPage, size: 10 });
    searchProductIn({
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    });
  }
  const updateProductIn = async (data) => {
    data.companySeq = session.companySeq
    data.productSeq = clickedRow.productSeq
    await ProductInApi.request.put(data);
    searchProductStockManagement({ page: currentPage, size: 10 });
    searchProductIn({
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    });
  };
  const deleteProductIn = async (row) => {
    const params = [row.productInSeq];
    await ProductInApi.request.delete(params);
    searchProductStockManagement({ page: currentPage, size: 10 });
    searchProductIn({
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    });
  };

  const searchProductOut = (params) => {
    dispatch(productOutApi.request.get(params));
  };

  const addProductOut = async (data) => {
    data.companySeq = session.companySeq;
    data.productSeq = clickedRow.productSeq;
    data.documentFileBundleSeq = 1
    await productOutApi.request.post(data);

    searchProductOut({
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    });
  };
  const updateProductOut = async (data) => {
    data.companySeq = session.companySeq;
    data.productSeq = clickedRow.productSeq;
    await productOutApi.request.put(data);

    searchProductOut({
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    });
  };
  const deleteProductOut = async (row) => {
    const params = [row.productOutSeq]
    await productOutApi.request.delete(params);
    searchProductOut({
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    });
  };

  


  const handleProductStockManagementlRowClick = async (row) => {
    if (!row) {
      console.error('Invalid ProductStockManagement row:', row);
      return;
    }
    if (clickedRow && clickedRow.productSeq === row.productSeq) {
      setClickedRow(null);
      return;
    }
    setClickedRow(row)
    const params = {
      companySeq: session.companySeq,
      productSeq: row.productSeq
    };
    try {
      searchProductIn(params);
      searchProductOut(params);
    } catch (error) {
      console.error('Error fetching ProductStockManagement data:', error);
    }
  };

  const refresh = () => {
    const params = {
      companySeq: session.companySeq,
      page: currentPage,
      size: 10
    };
    searchProductStockManagement(params)
  }

  useEffect(() => {
    if(!clickedRow) return;
    const params = {
      companySeq: session.companySeq,
      productSeq: clickedRow.productSeq
    };
    try {
      searchProductIn(params);
      searchProductOut(params);
    } catch (error) {
      console.error('Error fetching ProductIn/Out :', error);
    }
  }, [clickedRow]);

  useEffect(() => {
    try {
      const params = {
        companySeq: session.companySeq,
        page: 1,
        size: 10
      };
      searchProductStockManagement(params);

    } catch (error) {
      console.error('Error fetching ProductStockManagement : ', error);
    } finally {

    }
  }, [dispatch, session]);

  const productStockManagementPaging = (page) => {
    setCurrentPage(page);
    const parmas = {
      companySeq : session.companySeq,
      page : page,
      size : 10
    }
    searchProductStockManagement(parmas)
  }

  // type 1 : 등록, 2 : 수정
  // category : 1 = 입고, 2 = 출고
  const openModal = (type, category, row = null) => {
    let action;
    let formFields
    if(category === 1){
      formFields = productInFormFields;
      if(type === 1){
        setModalTitle(<><FaWarehouse style={{ marginRight: '8px' }} /> 입고 등록</>)
        action = addProductIn;
      } else {
        setModalTitle(<><FaWarehouse style={{ marginRight: '8px' }} /> 입고 수정</>)
        action = updateProductIn;
      }
    } else {
      formFields = productOutFormFields
      if(type === 1){
        setModalTitle(<><FaWarehouse style={{ marginRight: '8px' }} /> 출고 등록</>)
        action = addProductOut;
      } else{
        setModalTitle(<><FaWarehouse style={{ marginRight: '8px' }} /> 출고 수정</>)
        action = updateProductOut;
      }
    }
    setIsOpen(true);
    setContent(
    <CrudModal
      type={type}
      formFields={formFields}
      formDatas={row || {}}
      onClose={closeModal}
      onSubmit={action}
    />);
  };

  // type : 1 = 입고 , 2 출고
  const promptDelete = useCallback((type, row) => {
    if ( !row || !type ) {
      return;
    }
    let massge;
    let action
    setModalTitle(<><FaInfo style={{ marginRight: '8px' }} /> 알림</>);

    switch (type) {
        case 1 : 
          massge = '입고 내역을 삭제하시겠습니까?';
          action = deleteProductIn;
          break;
        case 2 : 
          massge = "출고 내역을 삭제하시겠습니까?";
          action = deleteProductOut;
        break;
        default: return;
    }

    setContent(
      <ConfirmModal
        message={massge}
        onConfirmAction={() => {
          action(row);
          closeModal(); 
        }}
        onCancelAction={closeModal} 
        confirmText="삭제"
        cancelText="취소"
      />);
    setIsOpen(true); 
  }, [deleteProductIn, deleteProductOut, closeModal]);

  return (
    <div className="final-product-management">
      <Search
          search={searchProductStockManagement}
          formFields={productStockSearchFormFields}
          title={"제품"}
      />
      <div className="product-table-container">
        <Table
          title={<><FaWarehouse style={{ marginRight: '8px' }} /> 완제품 목록 </>}
          className="product-table"
          columns={productStockManageManagementColumns} 
          data={ProductStockManagement.data}
          page={ProductStockManagement.page}
          paging={productStockManagementPaging}
          onRowClick={handleProductStockManagementlRowClick}
          showSearchBar={false}
        />
      </div>
      { clickedRow && (
      <div className="bottom-tables-container">
        <div className="left-table">
          <Table
            className="incoming-product-table"
            title={<><FaWarehouse style={{ marginRight: '8px' }} /> 입고 처리 </>}
            columns={productInColumns(openModal, promptDelete)} 
            data={ProductIn.data} 
            onAddClick={() => openModal(1, 1)}
            showSearchBar={false}
          />
        </div>
        <div className="right-table">
          <Table
            className="outgoing-product-table"
            title={<><FaWarehouse style={{ marginRight: '8px' }} /> 출고 처리 </>}
            columns={productOutColumns(openModal, promptDelete)} 
            data={productOut.data} 
            onAddClick={() => openModal(1, 2)}
            showSearchBar={false}
          />
        </div>
      </div>
      )}
      <BaseModal
        children={content}
        title={modalTitle}
        isOpen={isOpen}
        onClose={closeModal}
      />
    </div>
  );
};

export default FinalProductManagement;
